import { EcranProfil } from '@/components/profil/ecran-profil';
import { deconnecter } from '@/lib/deconnexion';
import { exigerSession } from '@/lib/garde-session';
import { createFileRoute, useNavigate } from '@tanstack/react-router';

/** `/profil`: the page the profile entry of the shell leads to, behind the same session guard. It holds the logout. */
export const Route = createFileRoute('/profil')({
  beforeLoad: ({ location }) => {
    exigerSession(location.href);
  },
  component: ProfilPage,
});

function ProfilPage() {
  const navigate = useNavigate();
  return (
    <EcranProfil
      onLogout={() => {
        void deconnecter().then(() => navigate({ to: '/login' }));
      }}
    />
  );
}
